import React, { useEffect, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Const from 'const.json'
import './navHeader.scss';

const LINKS = [
    { label: Const.overview, id: "overview" },
    { label: Const.whoAreTheyComplainingAbout, id: "whoAreTheyComplainingAbout" },
    { label: Const.whatisTheComplaintAbout, id: "whatisTheComplaintAbout" },
    { label: Const.howToSubmit, id: "howToSubmit" },
    { label: Const.whoComplains, id: "whoComplains" },
    { label: Const.tableOfDistributionByNilonLevels2, id: "tableOfDistributionByNilonLevels" },
]
const NavHeader: React.FC = () => {
    const [activeSection, setActiveSection] = useState<{ [key: string]: boolean }>();

    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
        entries.forEach(entry => {
            setActiveSection(prev => ({ ...prev, [entry.target.id]: entry.isIntersecting }))
        });
    };
    useEffect(() => {
        const observer = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: '30px',
            threshold: [0.3],
        });

        const sections = document.querySelectorAll<HTMLElement>('.section');
        sections.forEach(section => observer.observe(section));

        return () => {
            sections.forEach(section => observer.unobserve(section));
        };
    }, []);

    const handleLinkClick = (id: string) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
            section.focus({ preventScroll: true });
        }
    };

    return (
        <div>
            <Navbar aria-label={Const.navOnThisPage} className="custom-header-navbar" role="navigation">
                <Nav className="ms-auto" >
                    {LINKS.map(link => (
                        <Nav.Link className={link.id} key={link.id} active={activeSection && !!activeSection[link.id]} href={`#${link.id}`} onClick={() => handleLinkClick(link.id)}>{link.label}</Nav.Link>
                    ))}
                </Nav>
            </Navbar>
        </div>
    );
};

export default NavHeader;

